// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"99":"f53cde00","354":"14642ae3","418":"dff53cde"}[chunkId] + ".js";
};